import { useTranslation } from "react-i18next";
import type { GetAvtalePrivatResponse } from "@/api/generated";
import { DescriptionList, DescriptionTerm } from "@/components";
import { formatDateStringInterval, formatPostnummer } from "@/utils";
import { BekreftelseDetaljerContainer } from "./BekreftelseDetaljerContainer";
import { BekreftelseSection } from "./BekreftelseSection";
import { BekreftelseTidspunkt } from "./BekreftelseTidspunkt";

export const BekreftelseAvtaleDetaljerPrivat = ({
  privatAvtale,
}: {
  privatAvtale: GetAvtalePrivatResponse | undefined;
}) => {
  const { t } = useTranslation();

  return (
    <BekreftelseDetaljerContainer>
      <BekreftelseTidspunkt
        opprettet={privatAvtale?.avtale.createdAt}
        endret={privatAvtale?.avtale.lastUpdatedAt}
        avbestilt={privatAvtale?.avtale.cancelledAt}
      />
      <BekreftelseSection
        title={t("pages.bekreftelse.avtale.privat.leverandør.tittel")}
      >
        <DescriptionList>
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.leverandør.navn"
            value={privatAvtale?.avtale.leverandør.name}
          />
        </DescriptionList>
      </BekreftelseSection>
      <BekreftelseSection
        title={t("pages.bekreftelse.avtale.privat.aktør.tittel")}
      >
        <DescriptionList>
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.aktør.innsender"
            value={privatAvtale?.avtale.bestiller.navn}
          />
        </DescriptionList>
      </BekreftelseSection>
      <BekreftelseSection
        title={t("pages.bekreftelse.avtale.privat.avtaleperiode.tittel")}
      >
        <DescriptionList>
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.avtaleperiode.dato"
            value={`${formatDateStringInterval(privatAvtale?.avtale.activeFromInclusive, privatAvtale?.avtale.activeToExclusive)}`}
          />
        </DescriptionList>
      </BekreftelseSection>
      <BekreftelseSection
        title={t("pages.bekreftelse.avtale.privat.informasjon-om-bolig.tittel")}
      >
        <DescriptionList>
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.informasjon-om-bolig.type-bolig"
            value={t("enums.boligType", {
              context:
                privatAvtale?.avtale.avtaleDetaljerPrivat?.boligType ??
                "Ukjent",
            })}
          />
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.informasjon-om-bolig.kundenummer"
            value={privatAvtale?.avtale.kundenummer}
          />
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.informasjon-om-bolig.måler-id"
            value={privatAvtale?.avtale.målerId}
          />
          <DescriptionTerm
            tranlsationFeltKey="pages.bekreftelse.avtale.privat.informasjon-om-bolig.adresse"
            value={`${privatAvtale?.avtale.avtaleDetaljerPrivat?.adresse}, ${formatPostnummer(privatAvtale?.avtale.avtaleDetaljerPrivat?.postnummer)} ${privatAvtale?.avtale.avtaleDetaljerPrivat?.sted}`}
          />
        </DescriptionList>
      </BekreftelseSection>
    </BekreftelseDetaljerContainer>
  );
};
